import { useLocation } from "wouter";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * FixBlockerLink — spójny, klikalny link „przejdź i napraw" pokazywany przy
 * komunikacie o braku zasobu (brak integracji / konta / avatara / arkusza…).
 *
 * Jeden wzorzec na cały system (VP-115): zamiast tekstu „…w Centrum Integracji"
 * user dostaje guzik, który deep-linkuje wprost do miejsca naprawy. Domyślnie
 * prowadzi do Centrum Integracji (`/integracje`); `open` rozwija i przewija do
 * konkretnej karty integracji (np. `meta`, `ghl`).
 *
 * Auto-powrót do kontekstu zapewnia przycisk „Wróć" strony docelowej
 * (`window.history.back()`) — nawigacja SPA przez `setLocation` zostawia wpis w
 * historii, więc user wraca dokładnie tam, skąd wyszedł.
 */
type Props = {
  /** Etykieta linku, np. „Otwórz Centrum Integracji". */
  label: string;
  /** Ścieżka docelowa. Domyślnie Centrum Integracji. */
  to?: string;
  /** ID integracji do rozwinięcia + przewinięcia w Centrum Integracji (dokleja `?open=<id>`). */
  open?: string;
  className?: string;
};

export function FixBlockerLink({ label, to = "/integracje", open, className }: Props): JSX.Element {
  const [, setLocation] = useLocation();
  const href = open ? `${to}?open=${open}` : to;

  return (
    <button
      type="button"
      onClick={() => setLocation(href)}
      className={cn(
        "inline-flex items-center gap-1 font-medium text-[#ef3e29] hover:text-[#d63520] transition-colors",
        className
      )}
    >
      {label}
      <ArrowRight className="w-3.5 h-3.5 shrink-0" />
    </button>
  );
}
